import { Drawer } from 'antd';
import React from 'react';
import { VaultFilesEmptyStateIcon, VaultSecureIcon, VaultUploadIcon } from '../../../modules/vault/assets/icons';
import {
    CenteredContent,
    CloseButton,
    DrawerHeader,
    Illustration,
    SecuredBadge,
    Subtitle,
    Title,
    UploadButton,
} from './CreateFromFilesDrawer.styles';

export default function CreateFromFilesDrawer({ open, onClose, onUploadClick }) {
    return (
        <Drawer
            visible={open}
            onClose={onClose}
            height="95vh"
            placement="bottom"
            closable={false}
            className='createFromFilesDrawer_mobile'
            destroyOnClose
        >
            <DrawerHeader>
                <Title>Create from files</Title>
                <CloseButton onClick={onClose}><DrawerCloseIcon /></CloseButton>
            </DrawerHeader>
            <CenteredContent>
                <Illustration>
                    <VaultFilesEmptyStateIcon />
                </Illustration>
                <Subtitle>Upload spreadsheet / K-1 / PFS / PPM etc.</Subtitle>
                <UploadButton onClick={onUploadClick}>
                    <VaultUploadIcon />
                    Upload any financial document
                </UploadButton>
            </CenteredContent>
                <SecuredBadge>
                    <VaultSecureIcon /> Secured
                </SecuredBadge>
        </Drawer>
    );
}

const DrawerCloseIcon = () => {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" y="8" width="28" height="28" rx="14" fill="#E8E9ED" />
            <path fillRule="evenodd" clipRule="evenodd" d="M26.4194 27.7301L16.5199 17.8306L17.5806 16.7699L27.4801 26.6694L26.4194 27.7301Z" fill="#585D66" />
            <path fillRule="evenodd" clipRule="evenodd" d="M27.4802 17.8306L17.5807 27.7301L16.52 26.6694L26.4195 16.7699L27.4802 17.8306Z" fill="#585D66" />
        </svg>
    )
}